import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import MessageCard from './MessageCard';
import { MDBCarousel, MDBCarouselInner, MDBCarouselItem, MDBView, MDBContainer } from"mdbreact";
// models
import Message from '../models/Message';
// styles
import './MessageCardCarousel.css';




const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        display: "flex",
        justifySelf: "flex-start",
        justifyContent: "flex-start",
        justifyItems: "flex-start",
        paddingLeft: 0,
        marginLeft: 0,
        lineHeight:"50px"
      },
    carousel: {
      },
    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
      },
  }));

const MessageCardCarousel = (props:any) => {
    const classes = useStyles();
    const cardsMessageList: Message[] = props.message.messageData;
    let itemCount = 0;
    return (
        <Box className={classes.root} justifyContent="start-flex">
            <MDBContainer className={classes.root}>
                <MDBCarousel
                    activeItem={1}
                    length={cardsMessageList.length}
                    showControls={cardsMessageList.length > 1 ? true:false}
                    showIndicators={true}
                    slide={true}
                    className="z-depth-1"
                >
                    <MDBCarouselInner>
                        {
                            cardsMessageList.map(message => {
                                ++itemCount;
                                return (
                                    <MDBCarouselItem itemId={itemCount}>
                                        <MDBView>
                                        <MessageCard itemIndex={message.messageIndex!} message={message} actions={props.actions} />
                                        </MDBView>
                                    </MDBCarouselItem>
                                );  
                            })
                        }
                    </MDBCarouselInner>
            </MDBCarousel>
        </MDBContainer>
    </Box>
      );
};



export default MessageCardCarousel;